import type { HolidayCreateSchemaInput } from '@repo/schemas/holiday/createHoliday';

import { holidayCreateSchema } from '@repo/schemas/holiday/createHoliday';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { HolidayService } from './holidayService';
import { HolidayKey } from './keys';

export function useCreateHoliday() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: HolidayCreateSchemaInput) => {
      const validatedPayload = holidayCreateSchema.decode(payload);
      return HolidayService.createHoliday(validatedPayload).then((response) => response.data);
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [HolidayKey.HOLIDAYS] });
      void queryClient.invalidateQueries({
        queryKey: [HolidayKey.HOLIDAYS_INFINITE],
      });
    },
  });
}
